"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9132],{

/***/ 95536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCopy2 = function SvgCopy2(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 13,
        height: 15,
        fill: "none",
        viewBox: "0 0 13 15"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#1D1E3D",
        d: "M9.333 0h-8C.597 0 0 .597 0 1.333v9.334h1.333V1.333h8zm2 2.667H4c-.737 0-1.333.596-1.333 1.333v9.333c0 .737.596 1.334 1.333 1.334h7.333c.737 0 1.334-.597 1.334-1.334V4c0-.737-.597-1.333-1.334-1.333m0 10.666H4V4h7.333z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCopy2);


/***/ }),

/***/ 39055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgEarth = function SvgEarth(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    })), _path2 || (_path2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEarth);


/***/ }),

/***/ 97724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgDragHandle = function SvgDragHandle(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 14,
        viewBox: "0 0 9 14"
    }, props), _g || (_g = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "#333",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 3,
        height: 3,
        x: 0.084,
        y: 0.928,
        rx: 1.5
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 3,
        height: 3,
        x: 5.084,
        y: 0.928,
        rx: 1.5
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 3,
        height: 3,
        x: 0.084,
        y: 5.928,
        rx: 1.5
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 3,
        height: 3,
        x: 5.084,
        y: 5.928,
        rx: 1.5
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 3,
        height: 3,
        x: 0.084,
        y: 10.928,
        rx: 1.5
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 3,
        height: 3,
        x: 5.084,
        y: 10.928,
        rx: 1.5
    }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDragHandle);


/***/ }),

/***/ 13225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_video_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    borderRadius: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Border Radius",
        labelDescription: "Set the border radius for both image and video (e.g., '10px', '50%')"
    },
    image: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Image",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [
                    "static/img/templates/long-template/boards/"
                ],
                label: "Select an Image"
            },
            alt: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            },
            isDecorative: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Decorative image(no alt)"
            },
            href: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Href"
            }
        }
    },
    video: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Video",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
                label: "Video",
                videoType: constants_video_types__WEBPACK_IMPORTED_MODULE_1__/* .PARAGRAPH_AND_ASSET_VIDEOS */ .rB
            },
            ariaLabel: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Video description (accessibility)",
                translatable: true
            },
            loop: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Loop"
            },
            playWhenVisible: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Play Only When Visible"
            },
            disableAutoplay: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Disable Autoplay (Autoplay will be disabled only if controls aren't hidden)"
            }
        }
    }
});


/***/ }),

/***/ 87210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ isFooterComponent; },
/* harmony export */   "WC": function() { return /* binding */ isMainContentComponent; },
/* harmony export */   "kr": function() { return /* binding */ isHeaderComponent; }
/* harmony export */ });
/* unused harmony export isBannerComponent */
/* harmony import */ var segments_desktop_header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90382);
/* harmony import */ var segments_desktop_footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31627);
/* harmony import */ var segments_desktop_banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12101);
/* harmony import */ var constants_segment_families__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19971);




var isHeaderComponent = function(segmentComponentName) {
    return segments_desktop_header__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[segmentComponentName];
};
var isFooterComponent = function(segmentComponentName) {
    return segments_desktop_footer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[segmentComponentName];
};
var isBannerComponent = function(segmentComponentName) {
    return segments_desktop_banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[segmentComponentName];
};
var isMainContentComponent = function(segmentComponentName) {
    // TODO: we might want to improve logic. For example assets are also not content component
    return !isHeaderComponent(segmentComponentName) && !isFooterComponent(segmentComponentName) && !isBannerComponent(segmentComponentName);
};


/***/ }),

/***/ 95947:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)["default"]);
var _colorConsts = __webpack_require__(273);
var ref = __webpack_require__(273), WHITE_COLOR_NAME = ref.WHITE_COLOR_NAME, RIVERSTONE_COLOR_NAME = ref.RIVERSTONE_COLOR_NAME, PROJECTS_ORANGE_COLOR_NAME = ref.PROJECTS_ORANGE_COLOR_NAME, MARKETING_RED_COLOR_NAME = ref.MARKETING_RED_COLOR_NAME, CRM_GREEN_COLOR_NAME = ref.CRM_GREEN_COLOR_NAME, DEV_GREEN_COLOR_NAME = ref.DEV_GREEN_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME = ref.WORK_OS_IRIS_COLOR_NAME, LIGHT_PROJECTS_ORANGE_COLOR_NAME = ref.LIGHT_PROJECTS_ORANGE_COLOR_NAME, LIGHT_MARKETING_RED_COLOR_NAME = ref.LIGHT_MARKETING_RED_COLOR_NAME, LIGHT_CRM_GREEN_COLOR_NAME = ref.LIGHT_CRM_GREEN_COLOR_NAME, LIGHT_DEV_GREEN_COLOR_NAME = ref.LIGHT_DEV_GREEN_COLOR_NAME, LIGHT_WORK_OS_IRIS_COLOR_NAME = ref.LIGHT_WORK_OS_IRIS_COLOR_NAME, DARK_PROJECTS_ORANGE_COLOR_NAME = ref.DARK_PROJECTS_ORANGE_COLOR_NAME, DARK_MARKETING_RED_COLOR_NAME = ref.DARK_MARKETING_RED_COLOR_NAME, DARK_CRM_GREEN_COLOR_NAME = ref.DARK_CRM_GREEN_COLOR_NAME, DARK_DEV_GREEN_COLOR_NAME = ref.DARK_DEV_GREEN_COLOR_NAME, DARK_WORK_OS_IRIS_COLOR_NAME = ref.DARK_WORK_OS_IRIS_COLOR_NAME, SPACE_BLUE_COLOR_NAME = ref.SPACE_BLUE_COLOR_NAME, SIGN_UP_WITH_PRODUCTS_COLOR_NAME = ref.SIGN_UP_WITH_PRODUCTS_COLOR_NAME, BACKGROUND_GRAY_COLOR_NAME = ref.BACKGROUND_GRAY_COLOR_NAME, BRAND_BLACK_TEXT_COLOR = ref.BRAND_BLACK_TEXT_COLOR, DODGER_BLUE_COLOR_NAME = ref.DODGER_BLUE_COLOR_NAME, BLUE_COLOR_NAME = ref.BLUE_COLOR_NAME, SPACE_BLUE_GRADIANT_COLOR_NAME = ref.SPACE_BLUE_GRADIANT_COLOR_NAME, SPACE_BLUE_VIDEO_ONLY_COLOR_NAME = ref.SPACE_BLUE_VIDEO_ONLY_COLOR_NAME, SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME = ref.SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME, ELEVATE_BANNER_GRADIANT_COLOR_NAME = ref.ELEVATE_BANNER_GRADIANT_COLOR_NAME, ELEVATE_BUTTON_GRADIANT_COLOR_NAME = ref.ELEVATE_BUTTON_GRADIANT_COLOR_NAME, BRAND_WORK_MANAGEMENT_PRIMARY_COLOR = ref.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR, BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01 = ref.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01, BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02 = ref.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02, BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01 = ref.BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01, BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02 = ref.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02, BRAND_PRIMARY_YELLOW = ref.BRAND_PRIMARY_YELLOW, BRAND_YELLOW_DARK_TINT_01 = ref.BRAND_YELLOW_DARK_TINT_01, BRAND_YELLOW_DARKER_TINT_02 = ref.BRAND_YELLOW_DARKER_TINT_02, BRAND_PRIMARY_RED = ref.BRAND_PRIMARY_RED, BRAND_RED_DARK_TINT_01 = ref.BRAND_RED_DARK_TINT_01, BRAND_RED_DARKER_TINT_02 = ref.BRAND_RED_DARKER_TINT_02, BRAND_PRIMARY_GREEN = ref.BRAND_PRIMARY_GREEN, BRAND_GREEN_DARK_TINT_01 = ref.BRAND_GREEN_DARK_TINT_01, BRAND_GREEN_DARKER_TINT_02 = ref.BRAND_GREEN_DARKER_TINT_02, BRAND_DARK_COLOR = ref.BRAND_DARK_COLOR, BRAND_BLACK_BACKGROUND_COLOR = ref.BRAND_BLACK_BACKGROUND_COLOR, CRM_PRIMARY_COLOR = ref.CRM_PRIMARY_COLOR, CRM_LIGHTER_TINT_01 = ref.CRM_LIGHTER_TINT_01, CRM_LIGHT_TINT_02 = ref.CRM_LIGHT_TINT_02, CRM_DARK_TINT_01 = ref.CRM_DARK_TINT_01, CRM_DARKER_TINT_02 = ref.CRM_DARKER_TINT_02, CRM_DARK_TINT_01_COLOR_NAME = ref.CRM_DARK_TINT_01_COLOR_NAME, CRM_DARKER_TINT_02_COLOR_NAME = ref.CRM_DARKER_TINT_02_COLOR_NAME, DEV_PRIMARY_COLOR = ref.DEV_PRIMARY_COLOR, DEV_LIGHTER_TINT_01 = ref.DEV_LIGHTER_TINT_01, DEV_LIGHTER_TINT_01_COLOR_NAME = ref.DEV_LIGHTER_TINT_01_COLOR_NAME, DEV_LIGHT_TINT_02 = ref.DEV_LIGHT_TINT_02, DEV_DARK_TINT_01 = ref.DEV_DARK_TINT_01, DEV_DARKER_TINT_02 = ref.DEV_DARKER_TINT_02, MARKETER_PRIMARY_COLOR = ref.MARKETER_PRIMARY_COLOR, MARKETER_LIGHTER_TINT_01 = ref.MARKETER_LIGHTER_TINT_01, MARKETER_LIGHT_TINT_02 = ref.MARKETER_LIGHT_TINT_02, MARKETER_DARK_TINT_01 = ref.MARKETER_DARK_TINT_01, MARKETER_DARKER_TINT_02 = ref.MARKETER_DARKER_TINT_02, PROJECTS_PRIMARY_COLOR = ref.PROJECTS_PRIMARY_COLOR, PROJECTS_LIGHTER_TINT_01 = ref.PROJECTS_LIGHTER_TINT_01, PROJECTS_LIGHT_TINT_02 = ref.PROJECTS_LIGHT_TINT_02, PROJECTS_DARK_TINT_01 = ref.PROJECTS_DARK_TINT_01, PROJECTS_DARKER_TINT_02 = ref.PROJECTS_DARKER_TINT_02, PROJECTS_DARKEST_TINT_03 = ref.PROJECTS_DARKEST_TINT_03, CRM_PRIMARY_NEW_COLOR_NAME = ref.CRM_PRIMARY_NEW_COLOR_NAME, SERVICE_MAIN_COLOR_NAME = ref.SERVICE_MAIN_COLOR_NAME, SERVICE_LIGHT_COLOR_NAME = ref.SERVICE_LIGHT_COLOR_NAME, WM_SLACK_COLOR_NAME = ref.WM_SLACK_COLOR_NAME, WM_LIGHT_COLOR_NAME = ref.WM_LIGHT_COLOR_NAME, BRAND_LIGHT_COLOR_NAME = ref.BRAND_LIGHT_COLOR_NAME;
var colorOptions = [
    {
        value: "brand-red",
        label: "Red"
    },
    {
        value: "brand-enterprise-dark",
        label: "Dark Enterprise"
    },
    {
        value: "brand-green",
        label: "Green"
    },
    {
        value: "brand-purple",
        label: "Purple"
    },
    {
        value: "brand-pink",
        label: "Pink"
    },
    {
        value: "brand-blue",
        label: "Blue"
    },
    {
        value: "brand-iris",
        label: "Iris"
    },
    {
        value: "brand-light-blue",
        label: "Light Blue"
    },
    {
        value: "brand-dark-blue",
        label: "Dark Blue"
    },
    {
        value: "transparent",
        label: "Transparent"
    },
    {
        value: "snow",
        label: "Snow"
    },
    {
        value: "purple",
        label: "Purple"
    },
    {
        value: "iris",
        label: "Iris"
    },
    {
        value: "royal",
        label: "Royal"
    },
    {
        value: "green",
        label: "Green"
    },
    {
        value: "yellow",
        label: "Yellow"
    },
    {
        value: RIVERSTONE_COLOR_NAME,
        label: "Riverstone"
    },
    {
        value: "pink",
        label: "Pink"
    },
    {
        value: BLUE_COLOR_NAME,
        label: "Blue"
    },
    {
        value: "enterprise",
        label: "Enterprise Blue"
    },
    {
        value: "gradiant-gray",
        label: "Gradiant Gray"
    },
    {
        value: _colorConsts.GRADIANT_BRAND_GRAY_COLOR_NAME,
        label: "Gradiant Brand Gray (new)"
    },
    {
        value: "gradiant-pink",
        label: "Gradiant Pink"
    },
    {
        value: DODGER_BLUE_COLOR_NAME,
        label: "Dodger Blue"
    },
    {
        value: "light-blue",
        label: "Light Blue"
    },
    {
        value: "green-2",
        label: "Green"
    },
    {
        value: "dark-green",
        label: "Grass Green"
    },
    {
        value: "bright-green",
        label: "Bright Green"
    },
    {
        value: "saladish",
        label: "Saladish"
    },
    {
        value: "dark-orange",
        label: "Dark Orange"
    },
    {
        value: "brand-yellow",
        label: "Egg Yolk"
    },
    {
        value: "red",
        label: "Dark Red"
    },
    {
        value: "sofia-pink",
        label: "Sofia Pink"
    },
    {
        value: "lipstick",
        label: "Lipstick"
    },
    {
        value: "dark-purple",
        label: "Dark purple"
    },
    {
        value: "purple-v2",
        label: "Purple"
    },
    {
        value: "orange",
        label: "Orange"
    },
    {
        value: "dark-blue-v2",
        label: "Dark Blue"
    },
    {
        value: "light-blue-v2",
        label: "Light Blue"
    },
    {
        value: "chill-blue",
        label: "Chill Blue"
    },
    {
        value: "silver",
        label: "Explosive"
    },
    {
        value: "brand-gray",
        label: "American Gray"
    },
    {
        value: WHITE_COLOR_NAME,
        label: "White"
    },
    {
        value: _colorConsts.GAINSBORO_COLOR_NAME,
        label: "Gainsboro"
    },
    {
        value: "brown",
        label: "Brown"
    },
    {
        value: "sunset",
        label: "Sunset"
    },
    {
        value: "bubble",
        label: "Bubble"
    },
    {
        value: "peach",
        label: "Peach"
    },
    {
        value: "berry",
        label: "Berry"
    },
    {
        value: "winter",
        label: "Winter"
    },
    {
        value: "river",
        label: "River"
    },
    {
        value: "navy",
        label: "Navy"
    },
    {
        value: "aquamarine",
        label: "Aquamarine"
    },
    {
        value: "indigo",
        label: "Indigo"
    },
    {
        value: "dark-indigo",
        label: "Dark Indigo"
    },
    {
        value: MARKETING_RED_COLOR_NAME,
        label: "Marketing red"
    },
    {
        value: CRM_GREEN_COLOR_NAME,
        label: "CRM green"
    },
    {
        value: PROJECTS_ORANGE_COLOR_NAME,
        label: "Projects orange"
    },
    {
        value: DEV_GREEN_COLOR_NAME,
        label: "Software green"
    },
    {
        value: WORK_OS_IRIS_COLOR_NAME,
        label: "Brand & WM Primary Color"
    },
    {
        value: _colorConsts.WORKFORMS_RED_COLOR_NAME,
        label: "Workforms red"
    },
    {
        value: LIGHT_MARKETING_RED_COLOR_NAME,
        label: "Marketing red - light"
    },
    {
        value: LIGHT_CRM_GREEN_COLOR_NAME,
        label: "CRM green - light"
    },
    {
        value: LIGHT_PROJECTS_ORANGE_COLOR_NAME,
        label: "Projects orange - light"
    },
    {
        value: LIGHT_DEV_GREEN_COLOR_NAME,
        label: "Software green - light"
    },
    {
        value: LIGHT_WORK_OS_IRIS_COLOR_NAME,
        label: "Work OS Iris - light"
    },
    {
        value: DARK_MARKETING_RED_COLOR_NAME,
        label: "Marketing red - dark"
    },
    {
        value: DARK_CRM_GREEN_COLOR_NAME,
        label: "CRM green - dark"
    },
    {
        value: DARK_PROJECTS_ORANGE_COLOR_NAME,
        label: "Projects orange - dark"
    },
    {
        value: DARK_DEV_GREEN_COLOR_NAME,
        label: "Software green - dark"
    },
    {
        value: DARK_WORK_OS_IRIS_COLOR_NAME,
        label: "Work OS Iris - dark"
    },
    {
        value: SPACE_BLUE_COLOR_NAME,
        label: "Space blue"
    },
    {
        value: SIGN_UP_WITH_PRODUCTS_COLOR_NAME,
        label: "Sign up with products background"
    },
    {
        value: BACKGROUND_GRAY_COLOR_NAME,
        label: "Background gray"
    },
    {
        value: _colorConsts.RACKLEY_BLUE,
        label: "Rackley Blue"
    },
    {
        value: _colorConsts.LAVENDER_PURPLE_COLOR_NAME,
        label: "Lavender Purple"
    },
    {
        value: _colorConsts.LAVENDER_FROST_COLOR_NAME,
        label: "Lavender Frost"
    },
    {
        value: _colorConsts.AZURE_RADIANCE,
        label: "Azure Radiance"
    },
    {
        value: _colorConsts.TURQUOISE_BRIGHT_COLOR_NAME,
        label: "Turquoise Bright"
    },
    {
        value: _colorConsts.SILVER_MIST_COLOR_NAME,
        label: "Silver Mist"
    },
    {
        value: _colorConsts.CHARCOAL_GRAY_COLOR_NAME,
        label: "Charcoal Gray"
    },
    {
        value: _colorConsts.MOODY_PURPLE_COLOR_NAME,
        label: "Moody Purple"
    },
    {
        value: _colorConsts.ELECTRIC_BLUE_COLOR_NAME,
        label: "Electric Blue"
    },
    {
        value: _colorConsts.DARK_MARBLE_COLOR_NAME,
        label: "Dark marble"
    },
    {
        value: _colorConsts.BRIGHT_SEA_GREEN_COLOR_NAME,
        label: "Bright Sea Green"
    },
    {
        value: _colorConsts.PERIWINKLE_BLUE_COLOR_NAME,
        label: "Periwinkle Blue"
    },
    {
        value: _colorConsts.SOFT_AZURE_COLOR_NAME,
        label: "Soft Azure"
    },
    {
        value: _colorConsts.BRIGHT_LAVENDER_COLOR_NAME,
        label: "Bright Lavender"
    },
    {
        value: _colorConsts.ROUGE_RED,
        label: "Rouge Red"
    },
    {
        value: _colorConsts.SPRING_GREEN,
        label: "Spring Green"
    },
    {
        value: SPACE_BLUE_GRADIANT_COLOR_NAME,
        label: "Space blue gradiant"
    },
    {
        value: SPACE_BLUE_VIDEO_ONLY_COLOR_NAME,
        label: "Don't use - Space blue video only"
    },
    {
        value: SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME,
        label: "Don't use - Space blue video only - desktop"
    },
    {
        value: ELEVATE_BANNER_GRADIANT_COLOR_NAME,
        label: "Elevate Banner"
    },
    {
        value: ELEVATE_BUTTON_GRADIANT_COLOR_NAME,
        label: "Elevate Button"
    },
    {
        value: BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
        label: "Brand & WM Primary Color"
    },
    {
        value: _colorConsts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
        label: "Brand & WM Contrast Color"
    },
    {
        value: BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01,
        label: "Brand & WM Lighter Tint 01"
    },
    {
        value: BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
        label: "Brand & WM Light Tint 02"
    },
    {
        value: BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
        label: "Brand & WM Dark Tint 01"
    },
    {
        value: BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02,
        label: "Brand & WM Darker Tint 02"
    },
    {
        value: BRAND_PRIMARY_YELLOW,
        label: "Brand Primary Yellow"
    },
    {
        value: BRAND_YELLOW_DARK_TINT_01,
        label: "Brand Yellow Dark Tint 01"
    },
    {
        value: BRAND_YELLOW_DARKER_TINT_02,
        label: "Brand Yellow Darker Tint 02"
    },
    {
        value: BRAND_PRIMARY_RED,
        label: "Brand Primary Red"
    },
    {
        value: BRAND_RED_DARK_TINT_01,
        label: "Brand Red Dark Tint 01"
    },
    {
        value: BRAND_RED_DARKER_TINT_02,
        label: "Brand Red Darker Tint 02"
    },
    {
        value: BRAND_PRIMARY_GREEN,
        label: "Brand Primary Green"
    },
    {
        value: BRAND_GREEN_DARK_TINT_01,
        label: "Brand Green Dark Tint 01"
    },
    {
        value: BRAND_GREEN_DARKER_TINT_02,
        label: "Brand Green Darker Tint 02"
    },
    {
        value: BRAND_DARK_COLOR,
        label: "Dark"
    },
    {
        value: BRAND_BLACK_TEXT_COLOR,
        label: "Blackish Text Color"
    },
    {
        value: BRAND_BLACK_BACKGROUND_COLOR,
        label: "Black Background Color"
    },
    {
        value: CRM_PRIMARY_COLOR,
        label: "CRM Primary Color"
    },
    {
        value: CRM_LIGHTER_TINT_01,
        label: "CRM Lighter Tint 01"
    },
    {
        value: CRM_LIGHT_TINT_02,
        label: "CRM Light Tint 02"
    },
    {
        value: CRM_DARK_TINT_01_COLOR_NAME,
        label: "CRM Dark Tint 01"
    },
    {
        value: CRM_DARKER_TINT_02_COLOR_NAME,
        label: "CRM Darker Tint 02"
    },
    {
        value: DEV_PRIMARY_COLOR,
        label: "Dev Primary Color"
    },
    {
        value: DEV_LIGHTER_TINT_01_COLOR_NAME,
        label: "Dev Lighter Tint 01"
    },
    {
        value: DEV_LIGHT_TINT_02,
        label: "Dev Light Tint 02"
    },
    {
        value: DEV_DARK_TINT_01,
        label: "Dev Dark Tint 01"
    },
    {
        value: DEV_DARKER_TINT_02,
        label: "Dev Darker Tint 02"
    },
    {
        value: MARKETER_PRIMARY_COLOR,
        label: "Marketer Primary Color"
    },
    {
        value: MARKETER_LIGHTER_TINT_01,
        label: "Marketer Lighter Tint 01"
    },
    {
        value: MARKETER_LIGHT_TINT_02,
        label: "Marketer Light Tint 02"
    },
    {
        value: MARKETER_DARK_TINT_01,
        label: "Marketer Dark Tint 01"
    },
    {
        value: MARKETER_DARKER_TINT_02,
        label: "Marketer Darker Tint 02"
    },
    {
        value: PROJECTS_PRIMARY_COLOR,
        label: "Projects Primary Color"
    },
    {
        value: PROJECTS_LIGHTER_TINT_01,
        label: "Projects Lighter Tint 01"
    },
    {
        value: PROJECTS_LIGHT_TINT_02,
        label: "Projects Light Tint 02"
    },
    {
        value: PROJECTS_DARK_TINT_01,
        label: "Projects Dark Tint 01"
    },
    {
        value: PROJECTS_DARKER_TINT_02,
        label: "Projects Darker Tint 02"
    },
    {
        value: PROJECTS_DARKEST_TINT_03,
        label: "Projects Darkest Tint 03"
    },
    {
        value: _colorConsts.FIRST_FOLD_MOTION_INDIGO_COLOR,
        label: "First Fold Motion Indigo Color"
    },
    {
        value: _colorConsts.MIDNIGHT_PURPLE_COLOR,
        label: "Midnight purple"
    },
    {
        value: _colorConsts.INDIGO_BLUE_COLOR,
        label: "Indigo blue"
    },
    {
        value: _colorConsts.AMETHYST_PURPLE_COLOR,
        label: "Amethyst purple"
    },
    {
        value: _colorConsts.SAPPHIRE_PURPLE_COLOR,
        label: "Sapphire purple"
    },
    {
        value: _colorConsts.DEEP_NAVY_BLUE_COLOR,
        label: "Deep navy blue"
    },
    {
        value: CRM_PRIMARY_NEW_COLOR_NAME,
        label: "CRM Primary New Color"
    },
    {
        value: SERVICE_MAIN_COLOR_NAME,
        label: "Service Main Color"
    },
    {
        value: SERVICE_LIGHT_COLOR_NAME,
        label: "Service Light Color"
    },
    {
        value: WM_SLACK_COLOR_NAME,
        label: "WM Slack Color"
    },
    {
        value: WM_LIGHT_COLOR_NAME,
        label: "WM Light Color"
    },
    {
        value: BRAND_LIGHT_COLOR_NAME,
        label: "Brand Light Color"
    },
    {
        value: _colorConsts.DARK_SURFACE_COLOR_NAME,
        label: "Dark Surface"
    },
    {
        value: _colorConsts.CRM_CTA_COLOR_NAME,
        label: "CRM CTA Color"
    },
    {
        value: _colorConsts.DEV_CTA_COLOR_NAME,
        label: "Dev CTA Color"
    }
];
var _obj;
var productsColorOptionsOvertonesMap = (_obj = {}, _defineProperty(_obj, MARKETER_PRIMARY_COLOR, {
    light: MARKETER_LIGHT_TINT_02,
    dark: MARKETER_DARK_TINT_01
}), _defineProperty(_obj, CRM_PRIMARY_COLOR, {
    light: CRM_LIGHT_TINT_02,
    dark: CRM_DARK_TINT_01_COLOR_NAME
}), _defineProperty(_obj, PROJECTS_PRIMARY_COLOR, {
    light: PROJECTS_LIGHT_TINT_02,
    dark: PROJECTS_DARK_TINT_01
}), _defineProperty(_obj, DEV_PRIMARY_COLOR, {
    light: DEV_LIGHT_TINT_02,
    dark: DEV_DARK_TINT_01
}), _defineProperty(_obj, BRAND_WORK_MANAGEMENT_PRIMARY_COLOR, {
    light: BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
    dark: BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01
}), _obj);
var textColorOptions = [
    BRAND_BLACK_BACKGROUND_COLOR,
    WHITE_COLOR_NAME
];
var signupButtonColorOptions = [
    BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
    BRAND_BLACK_BACKGROUND_COLOR,
    WHITE_COLOR_NAME,
    _colorConsts.CRM_CTA_COLOR_NAME,
    _colorConsts.DEV_CTA_COLOR_NAME
];
var newBrandColors = [
    BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
    BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01,
    BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
    BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
    BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02,
    BRAND_PRIMARY_YELLOW,
    BRAND_YELLOW_DARK_TINT_01,
    BRAND_YELLOW_DARKER_TINT_02,
    BRAND_PRIMARY_RED,
    BRAND_RED_DARK_TINT_01,
    BRAND_RED_DARKER_TINT_02,
    BRAND_PRIMARY_GREEN,
    BRAND_GREEN_DARK_TINT_01,
    BRAND_GREEN_DARKER_TINT_02,
    BACKGROUND_GRAY_COLOR_NAME,
    WHITE_COLOR_NAME,
    BRAND_DARK_COLOR,
    BRAND_BLACK_BACKGROUND_COLOR,
    BRAND_BLACK_TEXT_COLOR,
    CRM_PRIMARY_COLOR,
    CRM_LIGHTER_TINT_01,
    CRM_LIGHT_TINT_02,
    CRM_DARK_TINT_01_COLOR_NAME,
    CRM_DARKER_TINT_02_COLOR_NAME,
    DEV_PRIMARY_COLOR,
    DEV_LIGHTER_TINT_01_COLOR_NAME,
    DEV_LIGHT_TINT_02,
    DEV_DARK_TINT_01,
    DEV_DARKER_TINT_02,
    MARKETER_PRIMARY_COLOR,
    MARKETER_LIGHTER_TINT_01,
    MARKETER_LIGHT_TINT_02,
    MARKETER_DARK_TINT_01,
    MARKETER_DARKER_TINT_02,
    PROJECTS_PRIMARY_COLOR,
    PROJECTS_LIGHTER_TINT_01,
    PROJECTS_LIGHT_TINT_02,
    PROJECTS_DARK_TINT_01,
    PROJECTS_DARKER_TINT_02,
    PROJECTS_DARKEST_TINT_03,
    _colorConsts.GAINSBORO_COLOR_NAME,
    CRM_PRIMARY_NEW_COLOR_NAME,
    SERVICE_MAIN_COLOR_NAME,
    SERVICE_LIGHT_COLOR_NAME,
    WM_SLACK_COLOR_NAME,
    WM_LIGHT_COLOR_NAME,
    BRAND_LIGHT_COLOR_NAME,
    _colorConsts.DARK_SURFACE_COLOR_NAME
];
var tagsSupportedColors = newBrandColors;
var productsColorOptions = newBrandColors;
var titleColorOptions = newBrandColors;
module.exports = {
    colorOptions: colorOptions,
    tagsSupportedColors: tagsSupportedColors,
    titleColorOptions: titleColorOptions,
    productsColorOptions: productsColorOptions,
    productsColorOptionsOvertonesMap: productsColorOptionsOvertonesMap,
    textColorOptions: textColorOptions,
    signupButtonColorOptions: signupButtonColorOptions,
    newBrandColors: newBrandColors
};


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ HEADER_POPUP_OPTIONS; },
/* harmony export */   "Yq": function() { return /* binding */ HEADER_POPUP_DATA; }
/* harmony export */ });
/* unused harmony exports RING_THE_BELL_VALUE, IPO_BLOG_POST_VALUE, ELEVATE_REGISTRATION_VALUE, RING_THE_BELL_TEXT, IPO_BLOG_POST_TEXT, ELEVATE_REGISTRATION_TEXT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72632);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_localization__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);




var RING_THE_BELL_VALUE = "ring_the_bell";
var IPO_BLOG_POST_VALUE = "ipo_blog_post";
var ELEVATE_REGISTRATION_VALUE = "elevate_registration";
var RING_THE_BELL_TEXT = "Ring the bell";
var IPO_BLOG_POST_TEXT = "IPO blog post";
var ELEVATE_REGISTRATION_TEXT = "Elevate Registration";
var HEADER_POPUP_OPTIONS = [
    {
        value: RING_THE_BELL_VALUE,
        text: RING_THE_BELL_TEXT
    },
    {
        value: IPO_BLOG_POST_VALUE,
        text: IPO_BLOG_POST_TEXT
    },
    {
        value: ELEVATE_REGISTRATION_VALUE,
        text: ELEVATE_REGISTRATION_TEXT
    }
];
var CLOUDINARY_BELL_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/ipo/ipo-bell-gif.gif";
var ELEVATE_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/elevate/star-rect.gif";
var ELEVATE_MOBILE_IMAGE_SRC = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/elevate/star-static.png";
var getRingTheBellLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .RING_THE_BELL_VIDEO_LINK */ .Kk$;
};
var getIpoBlogPostLink = function(locale) {
    switch(locale){
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.SPANISH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_SPANISH_LINK */ .zjT;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.PORTUGEESE_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_PORTUGESE_LINK */ .aL4;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.GERMAN_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_GERMAN_LINK */ .mF0;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.FRENCH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_FRENCH_LINK */ .div;
        default:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_LINK */ .vWk;
    }
};
var getElevateRegitrationLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ELEVATE_MAIN_PAGE_LINK */ .Csm;
};
var _obj;
var HEADER_POPUP_DATA = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, RING_THE_BELL_VALUE, {
    textKey: "header.ipo.popup.ringTheBell.mainText",
    ctaKey: "header.ipo.popup.ringTheBell.cta",
    getLink: getRingTheBellLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, IPO_BLOG_POST_VALUE, {
    textKey: "header.ipo.popup.ipoBlogPost.mainText",
    ctaKey: "header.ipo.popup.ipoBlogPost.cta",
    getLink: getIpoBlogPostLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ELEVATE_REGISTRATION_VALUE, {
    textKey: "header.elevate.popup.mainText",
    mobileTextKey: "header.elevate.popup.mobileText",
    ctaKey: "header.elevate.popup.cta",
    getLink: getElevateRegitrationLink,
    popupClassName: "elevate",
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .GRADIANT_ELEVATE_THEME_ID */ .wk,
    gifSrc: ELEVATE_GIF_SRC,
    mobileImageSrc: ELEVATE_MOBILE_IMAGE_SRC
}), _obj);


/***/ }),

/***/ 19971:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    COMPONENT: "COMPONENT"
});


/***/ }),

/***/ 40559:
/***/ (function(module) {


var FIELD_TYPES = {
    GALLERY: "gallery",
    CONSTANT: "constant",
    COMBO: "combo",
    BOOLEAN: "boolean",
    SEGMENTS: "segments",
    TEXT: "text",
    RICH_TEXT: "rich_text",
    DROPDOWN: "dropdown",
    NESTED: "nested",
    COLOR_PICKER: "colorPicker",
    VIDEO_PICKER: "videoPicker",
    CLOUDINARY_VIDEO_PICKER: "cloudinaryVideoPicker",
    MULTIPLE_TEXTS: "multipleTexts",
    MULTIPLE_NESTED: "multipleNested",
    DYNAMIC: "dynamic",
    HOMEPAGE_URL: "homepageUrl",
    TAGS: "tags",
    CATEGORIES: "categories",
    CLUSTERS: "clusters",
    SUB_CLUSTERS: "sub_clusters",
    FULLSTORY_RECORDING_FREQUENCY: "fullstory_recording_frequency",
    LOCALES: "locales",
    CONDITIONAL_NESTED: "conditionalNested",
    AUTOCOMPLETE: "autocomplete",
    SOLUTION: "solution",
    CALENDAR: "calendar",
    PRODUCTS: "products"
};
module.exports = {
    FIELD_TYPES: FIELD_TYPES
};


/***/ }),

/***/ 39832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bX": function() { return /* binding */ FULL_PAGE_BACKGROUND_VIDEOS; },
/* harmony export */   "rB": function() { return /* binding */ PARAGRAPH_AND_ASSET_VIDEOS; },
/* harmony export */   "u6": function() { return /* binding */ FULL_HEIGHT_VIDEOS; }
/* harmony export */ });
var FULL_PAGE_BACKGROUND_VIDEOS = "background-videos";
var FULL_HEIGHT_VIDEOS = "full-height-videos";
var PARAGRAPH_AND_ASSET_VIDEOS = "paragraph-and-asset-videos";


/***/ }),

/***/ 69132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ PreviewBaseSegmentContext; },
  "I": function() { return /* binding */ withPreviewBaseSegment; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/templates-generator/preview-base-segment/preview-base-segment-component.scss.js



var HOVER_BORDER = "2px dashed #c6e2e8"; // hard-coded color so no one else will use it
var SELECTED_BORDER = "2px solid ".concat(colors/* default.bold-blue */.Z["bold-blue"]);
var componentStyles = new String(".preview-base-segment-component{height:100%;width:100%;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background:white;cursor:pointer;&.preview-base-template-draggable-helper-element{overflow:hidden;-webkit-box-shadow:0px 2px 16px 0 rgba(0,0,0,.2);-moz-box-shadow:0px 2px 16px 0 rgba(0,0,0,.2);box-shadow:0px 2px 16px 0 rgba(0,0,0,.2);cursor:move;.preview-overlay,.base-layout-segment-component{zoom:50%}}&:hover,&.is-selected,&.preview-base-template-draggable-helper-element{.preview-overlay{border:".concat(HOVER_BORDER, ";opacity:1}}&.is-selected{.preview-overlay{border:").concat(SELECTED_BORDER, "}}.icon-wrapper{position:relative;margin:6px;background:white;-webkit-box-shadow:0 4px 8px 0 rgba(0,0,0,.16);-moz-box-shadow:0 4px 8px 0 rgba(0,0,0,.16);box-shadow:0 4px 8px 0 rgba(0,0,0,.16);-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;height:60px;width:60px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:-webkit-transform 150ms ease;-moz-transition:-moz-transform 150ms ease;-o-transition:-o-transform 150ms ease;transition:-webkit-transform 150ms ease;transition:-moz-transform 150ms ease;transition:-o-transform 150ms ease;transition:transform 150ms ease;pointer-events:all;z-index:").concat(z_index/* TOP_LAYER */.nA, ";svg {\n        height: 36px;\n        width: 36px;\n      }\n\n      &.location-icon-wrapper {\n        cursor: auto;\n        background: ").concat(colors/* default */.Z[color_consts.BRAND_PRIMARY_YELLOW], ";\n        z-index: ").concat(z_index/* TOP_LAYER */.nA, ";\n        position: absolute;\n        right: 32px;\n        top: 32px;\n      }\n    &:hover{-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}}.preview-overlay{position:absolute;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:32px 0 0 32px;top:0;right:0;bottom:0;left:0;z-index:").concat(z_index/* ALWAYS_ON_TOP */.OL, ";-webkit-transition:opacity 200ms ease;-moz-transition:opacity 200ms ease;-o-transition:opacity 200ms ease;transition:opacity 200ms ease;opacity:0;border:2px solid transparent;pointer-events:none;.icon-wrapper{&.drag-icon-wrapper{cursor:move}&.edit-icon-wrapper{cursor:pointer}&.remove-icon-wrapper{cursor:pointer}&.copy-icon-wrapper{cursor:pointer}&.paste-icon-wrapper{cursor:pointer}&.disabled{background:#d6d4d4;cursor:auto;&:hover{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}}}}.icon-wrapper-tooltip{font-size:1.238rem;top:45px!important;z-index:").concat(z_index/* TOP_LAYER */.nA, "}.has-copied{position:absolute;bottom:-20px;font-size:1rem}"));
componentStyles.__hash = "54eca55c0fb43286";

;// CONCATENATED MODULE: ./static/svg/pencil.svg
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgPencil = function SvgPencil(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#1D1E3D",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.795 1.21a2.42 2.42 0 0 0-3.438.023l-9.644 9.64L.5 15.5l4.628-1.213 9.643-9.64a2.42 2.42 0 0 0 .024-3.438M11.08 1.509l3.415 3.413M9.688 2.9l3.415 3.414"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#1D1E3D",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m1.713 10.873 2.394 1.022 1.024 2.389M11.395 4.607l-7.288 7.287"
    })));
};
/* harmony default export */ var pencil = (SvgPencil);

;// CONCATENATED MODULE: ./static/svg/bin.svg
var bin_path;
function bin_extends() {
    bin_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return bin_extends.apply(this, arguments);
}

var SvgBin = function SvgBin(props) {
    return /*#__PURE__*/ react.createElement("svg", bin_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), bin_path || (bin_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M1 3h14M9.5 1h-3a1 1 0 0 0-1 1v1h5V2a1 1 0 0 0-1-1M6.5 11.5v-5M9.5 11.5v-5M12.577 14.083a1 1 0 0 1-.997.917H4.42a1 1 0 0 1-.996-.917L2.5 3h11z"
    })));
};
/* harmony default export */ var bin = (SvgBin);

// EXTERNAL MODULE: ./static/svg/copy2.svg
var copy2 = __webpack_require__(95536);
;// CONCATENATED MODULE: ./static/svg/paste2.svg
var paste2_path;
function paste2_extends() {
    paste2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return paste2_extends.apply(this, arguments);
}

var SvgPaste2 = function SvgPaste2(props) {
    return /*#__PURE__*/ react.createElement("svg", paste2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 14,
        fill: "none",
        viewBox: "0 0 12 14"
    }, props), paste2_path || (paste2_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#1D1E3D",
        fillRule: "evenodd",
        d: "M1.333 0h8v1.333h-8v9.334H0V1.333C0 .597.597 0 1.333 0M3 5.35h1V4h2.1V3H4a1 1 0 0 0-1 1zM8.9 3v1H11v1.35h1V4a1 1 0 0 0-1-1zm0 11v-1H11v-1.35h1V13a1 1 0 0 1-1 1zm-2.8 0v-1H4v-1.35H3V13a1 1 0 0 0 1 1zM3 7.15h1v2.7H3zm9 2.7h-1v-2.7h1z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var paste2 = (SvgPaste2);

// EXTERNAL MODULE: ./node_modules/react-sortable-hoc/dist/react-sortable-hoc.umd.js
var react_sortable_hoc_umd = __webpack_require__(37905);
// EXTERNAL MODULE: ./static/svg/icons/drag-handle.svg
var drag_handle = __webpack_require__(97724);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js
var index_es = __webpack_require__(4726);
// EXTERNAL MODULE: ./static/svg/earth.svg
var earth = __webpack_require__(39055);
// EXTERNAL MODULE: ./components/templates/dynamic-template/dynamic-template-service.js
var dynamic_template_service = __webpack_require__(87210);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./components/templates-generator/preview-base-segment/preview-base-segment-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








 //to replace






var DragHandle = (0,react_sortable_hoc_umd.sortableHandle)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(drag_handle/* default */.Z, {});
});
var tooltipDelay = 250;
var PreviewBaseSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PreviewBaseSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PreviewBaseSegmentComponent);
    function PreviewBaseSegmentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, PreviewBaseSegmentComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "editComponent", function(e) {
            var _props = _this.props, index = _props.index, setSelectedSegmentIndex = _props.setSelectedSegmentIndex;
            setSelectedSegmentIndex(index);
            e.stopPropagation();
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "removeSegment", function(e) {
            var _props = _this.props, index = _props.index, onRemoveSegment = _props.onRemoveSegment;
            onRemoveSegment(index);
            e.stopPropagation();
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "copySegmant", function(e) {
            var _props = _this.props, setCopiedSegment = _props.setCopiedSegment, segment = _props.segment;
            setCopiedSegment(segment);
            e.stopPropagation();
            _this.setState({
                hasCopied: true
            });
            setTimeout(function() {
                _this.setState({
                    hasCopied: false
                });
            }, 2000);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "pasteSegment", function(e) {
            // if not allowed to paste, do nothing
            if (_this.isPasteSegmentDisabled()) return;
            var _props = _this.props, copiedSegment = _props.copiedSegment, onPasteSegment = _props.onPasteSegment, index = _props.index;
            if (!copiedSegment) return;
            onPasteSegment(index, copiedSegment);
            e.stopPropagation();
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getPreviewBaseLayoutStyle", function() {
            var segment = _this.props.segment;
            return segment.props && segment.props.baseLayoutStyleProps;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "childrenRendererWithoutBaseLayoutStyles", function() {
            var children = _this.props.children;
            if (!(children && children.props && children.props.segment && children.props.segment.props)) {
                return children;
            }
            //remove baseLayoutStyleProps from baseLayout - because we add these styles to the preview in getPreviewBaseLayoutStyle()
            var newProps = _object_spread_props(_object_spread({}, children.props), {
                segment: _object_spread_props(_object_spread({}, children.props.segment), {
                    props: _object_spread_props(_object_spread({}, children.props.segment.props), {
                        baseLayoutStyleProps: null
                    })
                })
            });
            return /*#__PURE__*/ (0,react.cloneElement)(children, newProps);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "isPasteSegmentDisabled", function() {
            var _props = _this.props, copiedSegment = _props.copiedSegment, segment = _props.segment;
            return !copiedSegment || (0,dynamic_template_service/* isFooterComponent */.LS)(segment === null || segment === void 0 ? void 0 : segment.type);
        });
        _this.state = {
            hasCopied: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(PreviewBaseSegmentComponent, [
        {
            key: "shouldShowLocationIcon",
            value: function shouldShowLocationIcon() {
                var children = this.props.children;
                var countrySpecificDisplaySettings = children.props.segment.props.countrySpecificDisplaySettings;
                return (countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.countryDisplayMode) && (countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.country);
            }
        },
        {
            key: "getLocationIconDataTip",
            value: function getLocationIconDataTip() {
                var children = this.props.children;
                var countrySpecificDisplaySettings = children.props.segment.props.countrySpecificDisplaySettings;
                if (!countrySpecificDisplaySettings) return "";
                var countryDisplayMode = countrySpecificDisplaySettings.countryDisplayMode, country = countrySpecificDisplaySettings.country;
                return "".concat(countryDisplayMode === shared_advanced_fields_config/* COUNTRY_DISPLAY_MODE.INCLUDE */.Us.INCLUDE ? "Show" : "Hidden", " only on ").concat(country);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, selectedSegmentIndex = _props.selectedSegmentIndex, index = _props.index;
                var hasCopied = this.state.hasCopied;
                var isSelected = selectedSegmentIndex === index;
                var style = this.getPreviewBaseLayoutStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: style,
                    onClick: this.editComponent,
                    className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("preview-base-segment-component", {
                        "is-selected": isSelected
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(componentStyles.__hash) + " " + "preview-overlay",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    "data-for": "tooltip_drag_".concat(index),
                                    "data-tip": "Reorder",
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "drag-icon-wrapper icon-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            multiline: false,
                                            className: "icon-wrapper-tooltip",
                                            id: "tooltip_drag_".concat(index),
                                            effect: "solid",
                                            place: "bottom",
                                            delayShow: tooltipDelay
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DragHandle, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    "data-for": "tooltip_edit_".concat(index),
                                    "data-tip": "Edit",
                                    onClick: this.editComponent,
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "edit-icon-wrapper icon-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            multiline: false,
                                            className: "icon-wrapper-tooltip",
                                            id: "tooltip_edit_".concat(index),
                                            effect: "solid",
                                            place: "bottom",
                                            delayShow: tooltipDelay
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pencil, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    "data-for": "tooltip_remove_".concat(index),
                                    "data-tip": "Remove",
                                    onClick: this.removeSegment,
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "remove-icon-wrapper icon-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            multiline: false,
                                            className: "icon-wrapper-tooltip",
                                            id: "tooltip_remove_".concat(index),
                                            effect: "solid",
                                            place: "bottom",
                                            delayShow: tooltipDelay
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bin, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    "data-for": "tooltip_copy_".concat(index),
                                    "data-tip": "Copy component",
                                    onClick: this.copySegmant,
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "copy-icon-wrapper icon-wrapper",
                                    children: [
                                        !hasCopied && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            multiline: false,
                                            className: "icon-wrapper-tooltip",
                                            id: "tooltip_copy_".concat(index),
                                            effect: "solid",
                                            place: "bottom",
                                            delayShow: tooltipDelay
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(copy2/* default */.Z, {}),
                                        hasCopied && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-".concat(componentStyles.__hash) + " " + "has-copied",
                                            children: "Copied!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: this.pasteSegment,
                                    "data-for": "tooltip_paste_".concat(index),
                                    "data-tip": "Paste component below",
                                    className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("paste-icon-wrapper", "icon-wrapper", {
                                        disabled: this.isPasteSegmentDisabled()
                                    }) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            multiline: false,
                                            className: "icon-wrapper-tooltip",
                                            id: "tooltip_paste_".concat(index),
                                            effect: "solid",
                                            place: "bottom",
                                            delayShow: tooltipDelay
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(paste2, {})
                                    ]
                                })
                            ]
                        }),
                        this.shouldShowLocationIcon() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-for": "tooltip_location_".concat(index),
                            "data-tip": this.getLocationIconDataTip(),
                            className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("location-icon-wrapper", "icon-wrapper", {
                                disabled: this.isPasteSegmentDisabled()
                            }) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                    multiline: false,
                                    className: "icon-wrapper-tooltip",
                                    id: "tooltip_location_".concat(index),
                                    effect: "solid",
                                    place: "bottom",
                                    delayShow: tooltipDelay
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(earth/* default */.Z, {})
                            ]
                        }),
                        this.childrenRendererWithoutBaseLayoutStyles(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return PreviewBaseSegmentComponent;
}(react.PureComponent);
/* harmony default export */ var preview_base_segment_component = ((0,react_sortable_hoc_umd.SortableElement)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewBaseSegmentComponent, _object_spread({}, props));
}));

;// CONCATENATED MODULE: ./contexts/preview-base-segment-context.js
function preview_base_segment_context_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function preview_base_segment_context_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            preview_base_segment_context_define_property(target, key, source[key]);
        });
    }
    return target;
}
function preview_base_segment_context_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function preview_base_segment_context_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        preview_base_segment_context_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var PreviewBaseSegmentContext = /*#__PURE__*/ (0,react.createContext)(null);
var withPreviewBaseSegment = function withPreviewBaseSegment(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewBaseSegmentContext.Consumer, {
            children: function(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(preview_base_segment_component, preview_base_segment_context_object_spread_props(preview_base_segment_context_object_spread({}, props, value), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, preview_base_segment_context_object_spread({}, props))
                }));
            }
        });
    };
};


/***/ }),

/***/ 60633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(861);


/* harmony default export */ __webpack_exports__["Z"] = ({
    theme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Theme",
        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_1__/* .BACKGROUND_COLOR_OPTIONS */ .L6
    }
});


/***/ }),

/***/ 12101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./segments/desktop/banner/layouts/plain-banner/index.js + 2 modules
var plain_banner = __webpack_require__(60644);
// EXTERNAL MODULE: ./segments/desktop/banner/layouts/with-background-banner/index.js + 2 modules
var with_background_banner = __webpack_require__(2690);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    PlainBanner: plain_banner/* default */.Z,
    WithBackgroundBanner: with_background_banner/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/banner/index.js

var PlainBanner = layouts.PlainBanner, WithBackgroundBanner = layouts.WithBackgroundBanner;
/* harmony default export */ var banner = ({
    // plop_marker:segment_index_add_layout
    PlainBannerComponent: {
        type: "PlainBannerComponent",
        title: "Plain",
        imgSrc: "/static/img/segments/layouts/plain-banner.png",
        config: PlainBanner.PlainBannerConfig,
        advancedConfig: PlainBanner.PlainBannerAdvancedConfig,
        component: PlainBanner.PlainBannerComponent
    },
    WithBackgroundBannerComponent: {
        type: "WithBackgroundBannerComponent",
        title: "With Background",
        imgSrc: "/static/img/segments/layouts/with-background-banner.png",
        config: WithBackgroundBanner.WithBackgroundBannerConfig,
        advancedConfig: WithBackgroundBanner.WithBackgroundBannerAdvancedConfig,
        component: WithBackgroundBanner.WithBackgroundBannerComponent
    }
});


/***/ }),

/***/ 60644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ plain_banner; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/fields-config.js
var fields_config = __webpack_require__(16353);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-config.js


/* harmony default export */ var plain_banner_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Plain",
    fields: fields_config/* default */.Z
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var plain_banner_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/index.js



var PlainBannerComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(9097)]).then(__webpack_require__.bind(__webpack_require__, 89097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89097)
            ];
        }
    }
});
/* harmony default export */ var plain_banner = ({
    PlainBannerComponent: PlainBannerComponent,
    PlainBannerConfig: plain_banner_config,
    PlainBannerAdvancedConfig: plain_banner_advanced_config
});


/***/ }),

/***/ 2690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ with_background_banner; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/fields-config.js
var fields_config = __webpack_require__(16353);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/with-background-banner/with-background-banner-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var with_background_banner_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "With Background",
    fields: _object_spread_props(_object_spread({}, fields_config/* default */.Z), {
        bannerleftImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Select an Left Image"
        },
        bannerRightImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Select an Right Image"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/with-background-banner/with-background-banner-advanced-config.js
function with_background_banner_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function with_background_banner_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            with_background_banner_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var with_background_banner_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: with_background_banner_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/with-background-banner/index.js



var WithBackgroundBannerComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(6304)]).then(__webpack_require__.bind(__webpack_require__, 86304));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86304)
            ];
        }
    }
});
/* harmony default export */ var with_background_banner = ({
    WithBackgroundBannerComponent: WithBackgroundBannerComponent,
    WithBackgroundBannerConfig: with_background_banner_config,
    WithBackgroundBannerAdvancedConfig: with_background_banner_advanced_config
});


/***/ }),

/***/ 16353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75650);
/* harmony import */ var segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64054);
/* harmony import */ var segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54237);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96587);
/* harmony import */ var segments_desktop_core_components_button_youtube_popup_button_fields_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6690);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60633);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(861);
/* harmony import */ var segments_button_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93833);

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var ExtendedRegularButtonFieldsConfig = _object_spread_props(_object_spread({}, segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), {
    color: _object_spread_props(_object_spread({}, segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color */ .Z.color), {
        possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.possibleColors */ .Z.color.possibleColors).concat([
            segments_button_service__WEBPACK_IMPORTED_MODULE_8__/* .ELEVATE_BUTTON_COLLOR_NAME */ .u_
        ])
    })
});
/* harmony default export */ __webpack_exports__["Z"] = ({
    bannerText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    mobileBannerText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Mobile Text",
        translatable: true
    },
    bannerCta: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    bannerHeight: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Banner Min Height"
    },
    theme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Theme"
    },
    withCloseIcon: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show Close Button"
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Button",
        conditionalKeyName: "buttonType",
        options: [
            {
                text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_1__/* .REGULAR_BUTTON_TYPE */ .ys,
                fieldsConfig: ExtendedRegularButtonFieldsConfig
            },
            {
                text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_1__/* .SECONDARY_BUTTON_TYPE */ .jE,
                fieldsConfig: segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
            },
            {
                text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_1__/* .SIGNUP_BUTTON_TYPE */ .ge,
                fieldsConfig: segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
            },
            {
                text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_1__/* .YOUTUBE_POPUP_LINK_TYPE */ .F9,
                fieldsConfig: segments_desktop_core_components_button_youtube_popup_button_fields_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
            }
        ]
    },
    stickImagesToText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Stick images to text"
    },
    bannerIcon: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
        label: "Banner Icon"
    },
    bannerIconHeight: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Banner Icon Height"
    }
});


/***/ }),

/***/ 27609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87154);


/* harmony default export */ __webpack_exports__["Z"] = ({
    additionalText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Additional text (monday markup supported)",
        translatable: true
    },
    additionalTextMaxWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Additional text max width"
    },
    additionalTextPosition: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        options: [
            {
                value: constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_1__/* .SIDE */ .V,
                text: "Side"
            },
            {
                value: constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_1__/* .BELOW */ ._,
                text: "Below"
            }
        ],
        label: "Position of additional text",
        labelDescription: "mobile version will always be shown below"
    }
});


/***/ }),

/***/ 64054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_button_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93833);
/* harmony import */ var components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35061);
/* harmony import */ var segments_desktop_core_components_button_additional_text_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27609);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread({
    buttonSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Size",
        options: [
            {
                value: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_2__.SM,
                text: "Small"
            },
            {
                value: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_2__.MD,
                text: "Medium"
            },
            {
                value: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_2__.LG,
                text: "Large"
            }
        ]
    },
    buttonText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    url: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Url"
    },
    isOpenLinkInNewTab: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Open link in new tab"
    },
    color: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: segments_button_service__WEBPACK_IMPORTED_MODULE_1__/* .buttonColors */ .Is
    },
    outline: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Transparent button with color outline"
    }
}, segments_desktop_core_components_button_additional_text_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));


/***/ }),

/***/ 54237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_button_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93833);


/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    leftSideIcon: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Left side icon",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                label: "Icon"
            },
            size: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Size"
            }
        }
    },
    url: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Url"
    },
    platformUrl: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Platform url for existing accounts",
        labelDescription: "Optional. Use as relative path (e.g. /product_store/dev)"
    },
    color: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: segments_button_service__WEBPACK_IMPORTED_MODULE_1__/* .buttonColors */ .Is
    },
    isOpenLinkInNewTab: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Open link in new tab"
    }
});


/***/ }),

/***/ 96587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_additional_text_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27609);
/* harmony import */ var constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95947);
/* harmony import */ var constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_2__);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({
    buttonColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_2__.signupButtonColorOptions
    },
    useCtaText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use override default CTA"
    },
    ctaText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Override Default CTA",
        translatable: true
    },
    signupWithsolutionAppReferenceId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Solution Id:",
        labelDescription: "Leave blank unless signup with solution needed - enter the solution's app reference id"
    }
}, segments_desktop_core_components_button_additional_text_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    buttonId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Button ID",
        labelDescription: "board_kind in signup_main_cta_clicked BB event"
    },
    isMobileInputTransparent: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use mobile transparent input",
        labelDescription: "To be used in case of white button"
    },
    signupProductId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.PRODUCTS,
        label: "Product",
        labelDescription: "Signup to monday product"
    },
    signupClusterId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLUSTERS,
        label: "Cluster",
        labelDescription: "Use only in generic pages if you want to assign a cluster"
    },
    showGoogleConnectOnMobile: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Mobile Google connect",
        labelDescription: "Display google connect option in mobile pages"
    },
    googleSeparatorColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Mobile Google separator color",
        possibleColors: [
            "Black",
            "white",
            "dark-surface"
        ]
    },
    existingAccount: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Existing account",
        fields: {
            platformUrlOverrideForExistingAccount: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Platform url override for existing account",
                labelDescription: "Internal platform Url to redirect existing account to"
            },
            existingAccountCtaText: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Override Default CTA for existing account",
                translatable: true
            }
        }
    },
    buttonAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Button align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            }
        ]
    },
    useExperimentalAnimation: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use experimental animation"
    },
    forceInputHide: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show Button Only"
    }
}));


/***/ }),

/***/ 6690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_button_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93833);
/* harmony import */ var _button_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75650);
/* harmony import */ var segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64054);




var buttonSize = segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].buttonSize */ .Z.buttonSize;
/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonDisplayType: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Display type",
        options: [
            {
                value: _button_consts__WEBPACK_IMPORTED_MODULE_2__/* .SECONDARY_BUTTON_TYPE */ .jE,
                text: "Secondary"
            },
            {
                value: _button_consts__WEBPACK_IMPORTED_MODULE_2__/* .REGULAR_BUTTON_TYPE */ .ys,
                text: "Regular"
            }
        ]
    },
    buttonSize: buttonSize,
    buttonText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    videoId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Video ID"
    },
    color: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: segments_button_service__WEBPACK_IMPORTED_MODULE_1__/* .buttonColors */ .Is
    },
    isWithArrow: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "With arrow"
    },
    isWithIcon: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "With icon"
    },
    isWithIconInsteadOfArrow: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show icon instead of arrow"
    },
    iconColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Icon color",
        possibleColors: segments_button_service__WEBPACK_IMPORTED_MODULE_1__/* .buttonColors */ .Is
    }
});


/***/ }),

/***/ 32211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64054);


var buttonSize = segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].buttonSize */ .Z.buttonSize, color = segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color */ .Z.color, outline = segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].outline */ .Z.outline;
/* harmony default export */ __webpack_exports__["Z"] = ({
    contactSalesTranslateKey: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text override",
        options: [
            {
                value: "header.contactSales",
                text: "Contact sales"
            },
            {
                value: "header.requestADemo",
                text: "Request a demo"
            },
            {
                value: "pricingPage.get_quote",
                text: "Get a quote"
            }
        ]
    },
    scrollToElementId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Segment ID to scroll to",
        labelDescription: "If provided, the button will scroll to the element with this ID when clicked."
    },
    buttonSize: buttonSize,
    color: color,
    outline: outline
});


/***/ }),

/***/ 31627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer; }
});

// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/index.js + 2 modules
var base_footer = __webpack_require__(47153);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/remote-work-footer/remote-work-footer-config.js

/* harmony default export */ var remote_work_footer_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Remote Work",
    fields: {}
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/remote-work-footer/remote-work-footer-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var remote_work_footer_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/remote-work-footer/index.js



var RemoteWorkFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(9160), __webpack_require__.e(5641)]).then(__webpack_require__.bind(__webpack_require__, 96707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96707)
            ];
        }
    }
});
/* harmony default export */ var remote_work_footer = ({
    RemoteWorkFooterComponent: RemoteWorkFooterComponent,
    RemoteWorkFooterConfig: remote_work_footer_config,
    RemoteWorkFooterAdvancedConfig: remote_work_footer_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/welcome-new-joiners-footer/welcome-new-joiners-footer-config.js

/* harmony default export */ var welcome_new_joiners_footer_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Welcome New Joiners",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/welcome-new-joiners-footer/welcome-new-joiners-footer-advanced-config.js
function welcome_new_joiners_footer_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function welcome_new_joiners_footer_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            welcome_new_joiners_footer_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var welcome_new_joiners_footer_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: welcome_new_joiners_footer_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/welcome-new-joiners-footer/index.js



var WelcomeNewJoinersFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(5971)]).then(__webpack_require__.bind(__webpack_require__, 75971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75971)
            ];
        }
    }
});
/* harmony default export */ var welcome_new_joiners_footer = ({
    WelcomeNewJoinersFooterComponent: WelcomeNewJoinersFooterComponent,
    WelcomeNewJoinersFooterConfig: welcome_new_joiners_footer_config,
    WelcomeNewJoinersFooterAdvancedConfig: welcome_new_joiners_footer_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-config.js

/* harmony default export */ var long_footer_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Long",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-advanced-config.js
function long_footer_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function long_footer_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            long_footer_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var long_footer_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: long_footer_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/index.js



var LongFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(5657), __webpack_require__.e(9160), __webpack_require__.e(7357), __webpack_require__.e(1450)]).then(__webpack_require__.bind(__webpack_require__, 55408));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55408)
            ];
        }
    }
});
/* harmony default export */ var long_footer = ({
    LongFooterComponent: LongFooterComponent,
    LongFooterConfig: long_footer_config,
    LongFooterAdvancedConfig: long_footer_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/slim-footer/slim-footer-config.js

/* harmony default export */ var slim_footer_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Slim",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/slim-footer/slim-footer-advanced-config.js
function slim_footer_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function slim_footer_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            slim_footer_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var slim_footer_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: slim_footer_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/slim-footer/index.js



var SlimFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(5657), __webpack_require__.e(9160), __webpack_require__.e(7357), __webpack_require__.e(5442)]).then(__webpack_require__.bind(__webpack_require__, 97545));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97545)
            ];
        }
    }
});
/* harmony default export */ var slim_footer = ({
    SlimFooterComponent: SlimFooterComponent,
    SlimFooterConfig: slim_footer_config,
    SlimFooterAdvancedConfig: slim_footer_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/index.js
// plop_marker:layouts_import





/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    BaseFooter: base_footer/* default */.Z,
    RemoteWorkFooter: remote_work_footer,
    WelcomeNewJoinersFooter: welcome_new_joiners_footer,
    LongFooter: long_footer,
    SlimFooter: slim_footer
});

;// CONCATENATED MODULE: ./segments/desktop/footer/index.js

var BaseFooter = layouts.BaseFooter, RemoteWorkFooter = layouts.RemoteWorkFooter, WelcomeNewJoinersFooter = layouts.WelcomeNewJoinersFooter, LongFooter = layouts.LongFooter, SlimFooter = layouts.SlimFooter;
/* harmony default export */ var footer = ({
    // plop_marker:segment_index_add_layout
    BaseFooterComponent: {
        type: "BaseFooterComponent",
        title: "Base",
        imgSrc: "/static/img/segments/layouts/long-footer.png",
        config: BaseFooter.BaseFooterConfig,
        advancedConfig: BaseFooter.BaseFooterAdvancedConfig,
        component: BaseFooter.BaseFooterComponent
    },
    RemoteWorkFooterComponent: {
        type: "RemoteWorkFooterComponent",
        title: "Remote Work",
        imgSrc: "/static/img/segments/layouts/remote-work-footer.png",
        config: RemoteWorkFooter.RemoteWorkFooterConfig,
        advancedConfig: RemoteWorkFooter.RemoteWorkFooterAdvancedConfig,
        component: RemoteWorkFooter.RemoteWorkFooterComponent
    },
    WelcomeNewJoinersFooterComponent: {
        type: "WelcomeNewJoinersFooterComponent",
        title: "Welcome New Joiners",
        imgSrc: "/static/img/segments/layouts/welcome-new-joiners-footer.png",
        config: WelcomeNewJoinersFooter.WelcomeNewJoinersFooterConfig,
        advancedConfig: WelcomeNewJoinersFooter.WelcomeNewJoinersFooterAdvancedConfig,
        component: WelcomeNewJoinersFooter.WelcomeNewJoinersFooterComponent
    },
    LongFooterComponent: {
        type: "LongFooterComponent",
        title: "Long (OLD)",
        imgSrc: "/static/img/segments/layouts/long-footer.png",
        config: LongFooter.LongFooterConfig,
        advancedConfig: LongFooter.LongFooterAdvancedConfig,
        component: LongFooter.LongFooterComponent
    },
    SlimFooterComponent: {
        type: "SlimFooterComponent",
        title: "Slim (OLD)",
        imgSrc: "/static/img/segments/layouts/slim-footer.png",
        config: SlimFooter.SlimFooterConfig,
        advancedConfig: SlimFooter.SlimFooterAdvancedConfig,
        component: SlimFooter.SlimFooterComponent
    }
});


/***/ }),

/***/ 99633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LONG; },
/* harmony export */   "z": function() { return /* binding */ SLIM; }
/* harmony export */ });
var SLIM = "slim";
var LONG = "long";


/***/ }),

/***/ 47153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ base_footer; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/footer-consts.js
var footer_consts = __webpack_require__(99633);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-config.js


/* harmony default export */ var base_footer_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Base",
    fields: {
        footer_type: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Footer Type",
            options: [
                {
                    value: footer_consts/* SLIM */.z,
                    text: "Slim (For landing pages)"
                },
                {
                    value: footer_consts/* LONG */.F,
                    text: "Long (For website pages)"
                }
            ]
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var base_footer_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/index.js



var BaseFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(5657), __webpack_require__.e(9160), __webpack_require__.e(7357), __webpack_require__.e(2269)]).then(__webpack_require__.bind(__webpack_require__, 44574));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44574)
            ];
        }
    }
});
/* harmony default export */ var base_footer = ({
    BaseFooterComponent: BaseFooterComponent,
    BaseFooterConfig: base_footer_config,
    BaseFooterAdvancedConfig: base_footer_advanced_config
});


/***/ }),

/***/ 90382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/remote-work-header/remote-work-header-config.js

/* harmony default export */ var remote_work_header_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Remote Work",
    fields: {}
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/remote-work-header/remote-work-header-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var remote_work_header_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/remote-work-header/index.js



var RemoteWorkHeaderComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(4778), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(9160), __webpack_require__.e(1513), __webpack_require__.e(291), __webpack_require__.e(5771)]).then(__webpack_require__.bind(__webpack_require__, 73537));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73537)
            ];
        }
    }
});
/* harmony default export */ var remote_work_header = ({
    RemoteWorkHeaderComponent: RemoteWorkHeaderComponent,
    RemoteWorkHeaderConfig: remote_work_header_config,
    RemoteWorkHeaderAdvancedConfig: remote_work_header_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/developers-center-header/developers-center-header-config.js

/* harmony default export */ var developers_center_header_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Developers Center",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/developers-center-header/developers-center-header-advanced-config.js
function developers_center_header_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function developers_center_header_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            developers_center_header_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var developers_center_header_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: developers_center_header_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/developers-center-header/index.js

var DevelopersCenterHeaderComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(4425), __webpack_require__.e(3538)]).then(__webpack_require__.bind(__webpack_require__, 63538));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63538)
            ];
        }
    }
});


/* harmony default export */ var developers_center_header = ({
    DevelopersCenterHeaderComponent: DevelopersCenterHeaderComponent,
    DevelopersCenterHeaderConfig: developers_center_header_config,
    DevelopersCenterHeaderAdvancedConfig: developers_center_header_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/welcome-new-joiners-header/welcome-new-joiners-header-config.js

/* harmony default export */ var welcome_new_joiners_header_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Welcome New Joiners",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/welcome-new-joiners-header/welcome-new-joiners-header-advanced-config.js
function welcome_new_joiners_header_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function welcome_new_joiners_header_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            welcome_new_joiners_header_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var welcome_new_joiners_header_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: welcome_new_joiners_header_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/welcome-new-joiners-header/index.js



var WelcomeNewJoinersHeaderComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(4425), __webpack_require__.e(7372)]).then(__webpack_require__.bind(__webpack_require__, 87372));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87372)
            ];
        }
    }
});
/* harmony default export */ var welcome_new_joiners_header = ({
    WelcomeNewJoinersHeaderComponent: WelcomeNewJoinersHeaderComponent,
    WelcomeNewJoinersHeaderConfig: welcome_new_joiners_header_config,
    WelcomeNewJoinersHeaderAdvancedConfig: welcome_new_joiners_header_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/dynamic-header/dynamic-header-config.js

/* harmony default export */ var dynamic_header_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Dynamic",
    fields: {
        logoImage: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logo Image",
            fields: {
                src: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [],
                    label: "Select an Image (size: 167x42)"
                },
                href: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Href"
                }
            }
        },
        linkItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Links",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    label: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Label"
                    },
                    url: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Url"
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/dynamic-header/dynamic-header-advanced-config.js
function dynamic_header_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamic_header_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamic_header_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var dynamic_header_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: dynamic_header_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/dynamic-header/index.js



var DynamicHeaderComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(4425)]).then(__webpack_require__.bind(__webpack_require__, 14425));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14425)
            ];
        }
    }
});
/* harmony default export */ var dynamic_header = ({
    DynamicHeaderComponent: DynamicHeaderComponent,
    DynamicHeaderConfig: dynamic_header_config,
    DynamicHeaderAdvancedConfig: dynamic_header_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/index.js + 2 modules
var base_header = __webpack_require__(44564);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/regular-header/regular-header-config.js

/* harmony default export */ var regular_header_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: {
        showMenu: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Menu"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/regular-header/regular-header-advanced-config.js
function regular_header_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_header_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_header_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var regular_header_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_header_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/regular-header/index.js



var RegularHeaderComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(4778), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(9160), __webpack_require__.e(1513), __webpack_require__.e(291), __webpack_require__.e(961)]).then(__webpack_require__.bind(__webpack_require__, 73022));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73022)
            ];
        }
    }
});
/* harmony default export */ var regular_header = ({
    RegularHeaderComponent: RegularHeaderComponent,
    RegularHeaderConfig: regular_header_config,
    RegularHeaderAdvancedConfig: regular_header_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/index.js
// plop_marker:layouts_import






/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    RemoteWorkHeader: remote_work_header,
    DevelopersCenterHeader: developers_center_header,
    WelcomeNewJoinersHeader: welcome_new_joiners_header,
    DynamicHeader: dynamic_header,
    BaseHeader: base_header/* default */.Z,
    RegularHeader: regular_header
});

;// CONCATENATED MODULE: ./segments/desktop/header/index.js

var RemoteWorkHeader = layouts.RemoteWorkHeader, DevelopersCenterHeader = layouts.DevelopersCenterHeader, WelcomeNewJoinersHeader = layouts.WelcomeNewJoinersHeader, DynamicHeader = layouts.DynamicHeader, BaseHeader = layouts.BaseHeader, RegularHeader = layouts.RegularHeader;
/* harmony default export */ var header = ({
    // plop_marker:segment_index_add_layout
    RemoteWorkHeaderComponent: {
        type: "RemoteWorkHeaderComponent",
        title: "Remote Work",
        imgSrc: "/static/img/segments/layouts/remote-work-header.png",
        config: RemoteWorkHeader.RemoteWorkHeaderConfig,
        advancedConfig: RemoteWorkHeader.RemoteWorkHeaderAdvancedConfig,
        component: RemoteWorkHeader.RemoteWorkHeaderComponent
    },
    DevelopersCenterHeaderComponent: {
        type: "DevelopersCenterHeaderComponent",
        title: "Developers Center",
        imgSrc: "/static/img/segments/layouts/developers-center-header.png",
        config: DevelopersCenterHeader.DevelopersCenterHeaderConfig,
        advancedConfig: DevelopersCenterHeader.DevelopersCenterHeaderAdvancedConfig,
        component: DevelopersCenterHeader.DevelopersCenterHeaderComponent
    },
    WelcomeNewJoinersHeaderComponent: {
        type: "WelcomeNewJoinersHeaderComponent",
        title: "Welcome New Joiners",
        imgSrc: "/static/img/segments/layouts/welcome-new-joiners-header.png",
        config: WelcomeNewJoinersHeader.WelcomeNewJoinersHeaderConfig,
        advancedConfig: WelcomeNewJoinersHeader.WelcomeNewJoinersHeaderAdvancedConfig,
        component: WelcomeNewJoinersHeader.WelcomeNewJoinersHeaderComponent
    },
    DynamicHeaderComponent: {
        type: "DynamicHeaderComponent",
        title: "Dynamic",
        imgSrc: "/static/img/segments/layouts/dynamic-header.png",
        config: DynamicHeader.DynamicHeaderConfig,
        advancedConfig: DynamicHeader.DynamicHeaderAdvancedConfig,
        component: DynamicHeader.DynamicHeaderComponent
    },
    BaseHeaderComponent: {
        type: "BaseHeaderComponent",
        title: "Base",
        imgSrc: "/static/img/segments/layouts/base-header.png",
        config: BaseHeader.BaseHeaderConfig,
        advancedConfig: BaseHeader.BaseHeaderAdvancedConfig,
        component: BaseHeader.BaseHeaderComponent
    },
    RegularHeaderComponent: {
        type: "RegularHeaderComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-header.png",
        config: RegularHeader.RegularHeaderConfig,
        advancedConfig: RegularHeader.RegularHeaderAdvancedConfig,
        component: RegularHeader.RegularHeaderComponent
    }
});


/***/ }),

/***/ 44564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ base_header; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/fields-config.js
var fields_config = __webpack_require__(96587);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/fields-config.js
var regular_button_fields_config = __webpack_require__(64054);
// EXTERNAL MODULE: ./segments/desktop/core-components/contact-sales-button/fields-config.js
var contact_sales_button_fields_config = __webpack_require__(32211);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-config.js





var scrollToElementId = contact_sales_button_fields_config/* default.scrollToElementId */.Z.scrollToElementId;
/* harmony default export */ var base_header_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Base",
    fields: {
        showMenu: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Menu"
        },
        hideLogin: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide login button"
        },
        showButton: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Button"
        },
        hideLanguagePicker: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide Language Picker (when Show Menu is off)"
        },
        logoHref: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Override Logo Click URL"
        },
        logoSrc: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Override Logo Image"
        },
        contactSalesButton: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Contact sales button",
            fields: {
                scrollToElementId: scrollToElementId
            }
        },
        buttonConfig: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Button",
            conditionalKeyName: "buttonType",
            options: [
                {
                    text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                    fieldsConfig: fields_config/* default */.Z
                },
                {
                    text: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                    fieldsConfig: regular_button_fields_config/* default */.Z
                }
            ]
        },
        enableRequestADemoCTA: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "change contact sales CTA to request a demo"
        }
    }
});

// EXTERNAL MODULE: ./constants/header-popup.js
var header_popup = __webpack_require__(61167);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var base_header_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        logoPopup: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Logo Popup",
            options: header_popup/* HEADER_POPUP_OPTIONS */.G8
        },
        mobileStickySignup: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Mobile sticky signup (In test don't touch)"
        },
        shouldHaveEnhancedProducts: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show enhanced products in header (In test don't touch)"
        },
        mobileDarkHeader: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Mobile dark header (In test don't touch)"
        },
        simulateExistingAccountHeader: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use existing account header (welcome back page)"
        },
        showSuccessStoriesInHeader: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show success stories in header (In test don't touch)"
        },
        overrideClusterLogo: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Override cluster logo (don't touch)",
            fields: {
                url: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Override Logo Click URL"
                },
                src: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Override Logo Image"
                },
                alt: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Override Logo Alt Text"
                }
            }
        },
        shouldUseDynamicColor: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use first fold dynamic color (In test don't touch)"
        },
        removeContactSalesButton: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove contact sales button from header"
        },
        simulateCampaignsInHeader: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show campaigns in header (In test don't touch)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/index.js



var BaseHeaderComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(4778), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(9160), __webpack_require__.e(1513), __webpack_require__.e(291), __webpack_require__.e(7284)]).then(__webpack_require__.bind(__webpack_require__, 80291));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80291)
            ];
        }
    }
});
/* harmony default export */ var base_header = ({
    BaseHeaderComponent: BaseHeaderComponent,
    BaseHeaderConfig: base_header_config,
    BaseHeaderAdvancedConfig: base_header_advanced_config
});


/***/ }),

/***/ 69223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Us": function() { return /* binding */ COUNTRY_DISPLAY_MODE; }
/* harmony export */ });
/* unused harmony export CARD_BORDER_STYLE_TO_LABEL */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var services_countries_countries_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85010);
/* harmony import */ var services_countries_countries_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(services_countries_countries_service__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(273);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73759);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13225);








var COUNTRY_FILED_CONFIG = {
    country: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "countries",
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                country: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                    options: services_countries_countries_service__WEBPACK_IMPORTED_MODULE_2__.COUNTRIES_DROPDOWN_OPTIONS
                }
            }
        }
    }
};
var _obj;
var CARD_BORDER_STYLE_TO_LABEL = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.FULL, "Full (default)"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.TOP, "Only Top"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.BOTTOM, "Only bottom"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.NONE, "None"), _obj);
var COUNTRY_DISPLAY_MODE = {
    INCLUDE: "Include",
    EXCLUDE: "Exclude"
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    paddingTop: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Padding Top"
    },
    paddingBottom: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Padding Bottom"
    },
    mobilePaddingTop: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Mobile Padding Top"
    },
    visibilitySensorProps: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Visibility sensor",
        conditionalKeyName: "useVisibilitySensor",
        options: [
            {
                text: "Yes",
                fieldsConfig: {
                    useInfinitely: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                        label: "Use on every visibility change"
                    },
                    visibilityOffset: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Visibility sensor offset (px/percentages only)"
                    },
                    easeInEffect: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                        label: "Easing effect"
                    }
                }
            }
        ]
    },
    wrapInCard: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Wrap segment in card",
        conditionalKeyName: "active",
        options: [
            {
                text: "Yes",
                fieldsConfig: {
                    cardBackgroundColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Card background color",
                        possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].theme.possibleColors */ .Z.theme.possibleColors).concat([
                            styles_color_consts__WEBPACK_IMPORTED_MODULE_7__.DARK_MARBLE_COLOR_NAME
                        ])
                    },
                    cardAsset: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                        label: "Card asset",
                        fields: _components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
                    },
                    cardWidth: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Card max width"
                    },
                    cardPadding: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Card padding"
                    },
                    cardBorderStyle: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                        label: "Card border style",
                        options: [
                            {
                                value: segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.FULL,
                                text: CARD_BORDER_STYLE_TO_LABEL[segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.FULL]
                            },
                            {
                                value: segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.TOP,
                                text: CARD_BORDER_STYLE_TO_LABEL[segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.TOP]
                            },
                            {
                                value: segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.BOTTOM,
                                text: CARD_BORDER_STYLE_TO_LABEL[segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.BOTTOM]
                            },
                            {
                                value: segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.NONE,
                                text: CARD_BORDER_STYLE_TO_LABEL[segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.CARD_BORDER_STYLE.NONE]
                            }
                        ]
                    }
                }
            }
        ]
    },
    sticky: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Sticky segment",
        conditionalKeyName: "isSticky",
        options: [
            {
                text: "Yes",
                fieldsConfig: {
                    stickyTopOffset: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Sticky top offset"
                    }
                }
            }
        ]
    },
    countrySpecificDisplaySettings: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Country specific segment display",
        conditionalKeyName: "countryDisplayMode",
        options: [
            {
                text: COUNTRY_DISPLAY_MODE.INCLUDE,
                fieldsConfig: COUNTRY_FILED_CONFIG
            },
            {
                text: COUNTRY_DISPLAY_MODE.EXCLUDE,
                fieldsConfig: COUNTRY_FILED_CONFIG
            }
        ]
    },
    segmentMinHeight: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Segment min height"
    },
    mobilePaddingBottom: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Mobile Padding Bottom"
    },
    showOnDevice: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Show On Device",
        options: [
            {
                value: "all",
                text: "All Devices"
            },
            {
                value: "desktop",
                text: "Desktop Only"
            },
            {
                value: "mobile",
                text: "Mobile Only"
            }
        ]
    },
    hideOnMobile: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide segment on mobile (deprecated - use Show On Device instead)"
    },
    topTriangle: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Top triangle",
        fields: {
            isVisible: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Is visible"
            },
            color: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Color",
                possibleColors: segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].theme.possibleColors */ .Z.theme.possibleColors
            }
        }
    },
    bottomTriangle: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Bottom triangle",
        fields: {
            isVisible: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Is visible"
            },
            color: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Color",
                possibleColors: segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].theme.possibleColors */ .Z.theme.possibleColors
            }
        }
    },
    segmentId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        unAllowedChars: [
            "#"
        ],
        label: "Segment ID",
        labelDescription: "To link to this element insert the unique id (without # symbol). Consider adding 72px top padding (because of the header)"
    }
});


/***/ })

}]);